// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"aa7b5b5b","743":"73cebb1c","767":"73f3898f","777":"d5a28be3","993":"73cebb1c"}[chunkId] + ".css";
};